export const INFO_SITE = process.env.VUE_APP_INFO_SITE;
export const ALT_INFO_SITE = process.env.VUE_APP_ALT_INFO_SITE;
